module.exports = __webpack_public_path__ + "img/hr-branch-particle-16.d56f3327.png";